
<div>
  <highcharts :options="chart" :key="JSON.stringify(colors)"></highcharts>
</div>
